module.exports = __webpack_public_path__ + "img/124.ba64be63.gif";